import React from 'react'

export type TooltipPlacement = 'top' | 'bottom'| 'left' | 'right'

interface OracleTooltipProps {
  placement?: TooltipPlacement
  title?: string
  children: React.ReactNode
}

export const OracleTooltip: React.FC<OracleTooltipProps> = ({
  placement = 'top',
  title,
  children,
}) => {
  if (!title) {
    return <>{children}</>
  }

  return (
    <span className="oracle-tooltip">
      <span className={`oracle-tooltip__text oracle-tooltip__text--${placement}`}>
        {title}
      </span>
      {children}
    </span>
  )
}
